export const TICKS_PER_MILLISECOND = 10_000;

export const formats = {
    dateOnly: 'MM/DD',
    dateWithYear: 'MM/DD/yyyy',
    fullTime: 'HH:mm:ss.SSSSSS, MM/DD/YYYY',
};
